const TABLET_BREAKPOINT = 768;
const DESKTOP_BREAKPOINT = 1024;
const GUTTER_WIDTH = 16;
export const initSliders = (tns, sliderComponents) => {
    sliderComponents.forEach((sliderComponent) => {
        const items = sliderComponent.querySelector('.slider__items');
        if (!items) {
            return;
        }
        const numItems = sliderComponent.querySelectorAll('.slider__items > div').length;
        const desktopItems = parseInt(sliderComponent.dataset.desktopItems || '1');
        const tabletItems = parseInt(sliderComponent.dataset.tabletItems || '1');
        const mobileItems = parseInt(sliderComponent.dataset.mobileItems || '1');
        const startIndex = parseInt(sliderComponent.dataset.startIndex || '0');
        const fixedWidth = typeof sliderComponent.dataset.slideWidth === 'undefined'
            ? null
            : parseInt(sliderComponent.dataset.slideWidth);
        const prevButton = sliderComponent.querySelector('.slider__previous-button');
        const nextButton = sliderComponent.querySelector('.slider__next-button');
        const config = {
            container: items,
            items: mobileItems,
            slideBy: 'page',
            mouseDrag: true,
            swipeAngle: 30,
            speed: 500,
            nav: false,
            loop: true,
            center: false,
            arrowKeys: true,
            lazyload: false,
            preventScrollOnTouch: 'auto',
            navPosition: 'bottom',
            prevButton: prevButton,
            nextButton: nextButton,
            startIndex: startIndex,
        };
        if (typeof sliderComponent.dataset.edgePadding !== 'undefined' && sliderComponent.dataset.edgePadding !== '0') {
            config.edgePadding = parseInt(sliderComponent.dataset.edgePadding);
        }
        if (mobileItems > 1) {
            if (startIndex > 0) {
                config.center = true;
            }
        }
        if (fixedWidth) {
            config.fixedWidth = fixedWidth;
            if (mobileItems > 1) {
                config.fixedWidth += GUTTER_WIDTH;
            }
            delete config.items;
        }
        if (tabletItems !== mobileItems || desktopItems !== mobileItems) {
            const responsiveConfig = {};
            if (tabletItems !== mobileItems) {
                responsiveConfig[TABLET_BREAKPOINT] = {
                    items: tabletItems,
                };
                if (numItems <= tabletItems) {
                    responsiveConfig[TABLET_BREAKPOINT].disable = true;
                }
                if (fixedWidth && tabletItems > 1) {
                    responsiveConfig[TABLET_BREAKPOINT].fixedWidth = fixedWidth + GUTTER_WIDTH;
                }
            }
            if (desktopItems !== tabletItems) {
                responsiveConfig[DESKTOP_BREAKPOINT] = {
                    items: desktopItems,
                };
                if (startIndex > 1) {
                    responsiveConfig[TABLET_BREAKPOINT].center = false;
                }
                if (numItems <= desktopItems) {
                    responsiveConfig[DESKTOP_BREAKPOINT].disable = true;
                }
                if (fixedWidth) {
                    if (desktopItems > 1) {
                        responsiveConfig[DESKTOP_BREAKPOINT].fixedWidth = fixedWidth + GUTTER_WIDTH;
                    }
                    const totalRequiredWidth = fixedWidth * numItems;
                    if (DESKTOP_BREAKPOINT >= totalRequiredWidth) {
                        responsiveConfig[DESKTOP_BREAKPOINT].disable = true;
                    }
                }
            }
            config['responsive'] = responsiveConfig;
        }
        const slider = tns(config);
        if (!sliderComponent.classList.contains('slider--with-tabs')) {
            return;
        }
        const sliderTabs = sliderComponent.querySelectorAll('.slider__tab');
        if (sliderTabs.length < 2) {
            return;
        }
        sliderTabs[0].classList.add('active');
        sliderTabs.forEach((tab, index) => {
            tab.addEventListener('click', () => {
                slider.goTo(index);
            });
        });
        slider.events.on('indexChanged', (info) => {
            sliderTabs.forEach((tab, tabIndex) => tab.classList.toggle('active', info.index === tabIndex + 1));
        });
    });
};
